"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyType = void 0;
// export type TStrategyType = keyof typeof StrategyType;
exports.StrategyType = {
    MicroGrants: "MicroGrantsv1",
    Hats: "MicroGrantsHatsv1",
    Gov: "MicroGrantsGovv1",
};
